module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_4.1835f2b5.png";